import './AccountTable.css';

const AccountTable = ({ data = [], columns }) => {
  return (
    <div className="AccountTable-wrapper">
      <div className="AccountTable-container">
        <table className="AccountTable">
          <thead>
            <tr className='AccountTable-title'>
              {columns.map((column, index) => (
                typeof column === 'string' ? (
                  <th key={index} className={`AccountTable-${column.toLowerCase().replace(' ', '-')}`}>{column}</th>
                ) : (
                  <th key={index} className="AccountTable-image">{column}</th>
                )
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr className='AccountTable-content' key={rowIndex}>
                {columns.map((column, colIndex) => (
                  <td key={colIndex} className={`AccountTable-${typeof column === 'string' ? column.toLowerCase().replace(' ', '-') : 'image'}-content`}>
                    {row[typeof column === 'string' ? column.toLowerCase().replace(' ', '_') : 'image']}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AccountTable;
